import React, { useState, useEffect } from "react";
import CostumCalender from "./CostumCalender";
import { Col } from "react-bootstrap";
import Select from "react-select";
import api from "../../api";
import { getUserToken } from "helpers/authHelper";
import { toast } from "react-toastify";

export default function CalenderTime() {
  const userId = localStorage.getItem("user_id");
  const [isConfirmed, setIsConfirmed] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);
  const [tasks, setTasks] = useState([]);
  const [timeSlotsData, setTimeSlotsData] = useState([]);
  const [selectedTimeSlots, setSelectedTimeSlots] = useState([]);
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [zoneName, setZoneName] = useState("");
  const [startTime, setStartTime] = useState("");
  const [endTime, setEndTime] = useState("");
  const [loading, setLoading] = useState(false);
  const [timeslotDuration, setTimeslotDuration] = useState("1 hour");

  const timeslotOptions = [
    { value: "1 hour", label: "1 Hour" },
    { value: "30 minutes", label: "30 Minutes" },
  ];

  // Function to generate time slots based on the selected duration
  const generateTimeSlots = () => {
    const slots = [];
    let start = new Date(`2024-10-11T${startTime}:00`);
    const end = new Date(`2024-10-11T${endTime}:00`);
    const interval = timeslotDuration === "1 hour" ? 60 : 30;

    while (start < end) {
      let nextSlot = new Date(start);
      nextSlot.setMinutes(nextSlot.getMinutes() + interval);

      if (nextSlot <= end) {
        // Convert both start and nextSlot to AM/PM format
        const formattedStart = start.toLocaleTimeString([], {
          hour: "2-digit",
          minute: "2-digit",
          hour12: true,
        });
        const formattedEnd = nextSlot.toLocaleTimeString([], {
          hour: "2-digit",
          minute: "2-digit",
          hour12: true,
        });

        const formattedSlot = `${formattedStart} - ${formattedEnd}`;
        slots.push(formattedSlot);
      }

      start = nextSlot;
    }

    setTimeSlotsData(slots);
  };

  const fetchInterTimeslot = async interviewer_id => {
    setLoading(true);
    try {
      const response = await api.get(
        `${process.env.REACT_APP_API_URL}/admin/user/fetch-shift-timeslots/${interviewer_id}`,
      );

      const { userShiftDtl } = response.data;
      setZoneName(userShiftDtl.zone_name);
      setStartTime(userShiftDtl.startTime);
      setEndTime(userShiftDtl.endTime);
    } catch (error) {
      console.error("Error fetching time slots:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleSlotClick = index => {
    const selectedSlot = timeSlotsData[index];
    if (selectedTimeSlots.includes(selectedSlot)) {
      setSelectedTimeSlots(prevSlots =>
        prevSlots.filter(slot => slot !== selectedSlot)
      );
    } else {
      setSelectedTimeSlots(prevSlots => [...prevSlots, selectedSlot]);
    }
  };

  const handleDateChange = date => {
    setSelectedDate(date);
  };

  const addOneDay = dateString => {
    // Parse the input date string into a Date object
    const date = new Date(dateString);

    // Add 1 day to the date
    date.setDate(date.getDate() + 1);

    // Format the new date to 'yyyy-mm-dd'
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are zero-indexed
    const day = String(date.getDate()).padStart(2, "0");

    return `${year}-${month}-${day}`;
  };

  const convertToYYYYMMDD = dateString => {
    const date = new Date(dateString);
    const yyyy = date.getFullYear();
    const mm = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-based
    const dd = String(date.getDate()).padStart(2, "0");

    return `${yyyy}-${mm}-${dd}`;
  };

  const handleTimeslotDurationChange = option => {
    setTimeslotDuration(option.value);
    setSelectedTimeSlots([]); // Reset the selected time slots
    generateTimeSlots(); // Regenerate the slots when duration changes
  };

  const handleConfirm = async e => {
    e.preventDefault();
    const formattedDate = convertToYYYYMMDD(selectedDate);
    try {
      const payload = {
        InterviewerId: userId,
        date: formattedDate,
        timeSlotsData: selectedTimeSlots,
        companyID: localStorage.getItem("subdomainId"),
      };
      const response = await api.post(
        `${process.env.REACT_APP_API_URL}/admin/user/create-intertimeslot`,
        payload
      );
      console.log(response, "response");
      if (!response?.data?.status) {
        toast.error(response?.data?.message);
      } else {
        toast.success(response?.data?.message);
        history.push("/user-list");
      }
      const newDate = addOneDay(formattedDate);
      setSelectedDate(newDate);
      console.log(newDate, "newDate");
      // Submit the timeslots (API call)
    } catch (error) {
      console.error("Error saving time slots:", error);
    }
  };

  useEffect(() => {
    fetchInterTimeslot(userId);
  }, []);

  useEffect(() => {
    if (startTime && endTime) {
      generateTimeSlots(); // Generate slots after fetching shift data
    }
  }, [startTime, endTime, timeslotDuration]);

  const formatTime = time => {
    const date = new Date(`2024-10-11T${time}:00`); // Create a Date object
    return date.toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true, // Convert to 12-hour format with AM/PM
    });
  };

  const formatDate = date => {
    const dateObj = new Date(date);
    return dateObj.toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  };

  //console.log(selectedTimeSlots, "selectedTimeSlots");

  useEffect(() => {
    const theme = localStorage.getItem("company_theme");
    if (theme) {
      document.body.classList.add(`theme-${theme}`);
    }
  }, []);
  return (
    <>
      {!isConfirmed && (
        <div className="pending-list-page time-card">
          <div className="outerTab-box-wrapper">
            <Col lg={12}>
              <div className="interview-card-cale">
                <div className="calender-time-zone-card">
                  <CostumCalender onDateChange={handleDateChange} />

                  <div className="time-zone-card">
                    <div className="time-content">
                      <h4>
                        Available time slots showing for{" "}
                        <strong>
                          {formatDate(selectedDate) || "Select a Date"}
                        </strong>
                      </h4>
                      <p>
                        {zoneName} {startTime && formatTime(startTime)}{" "}
                        {endTime && formatTime(endTime)}
                      </p>

                      <Select
                        value={timeslotOptions.find(
                          option => option.value === timeslotDuration
                        )}
                        options={timeslotOptions}
                        onChange={handleTimeslotDurationChange}
                      />

                      {loading ? (
                        <p>Loading time slots...</p>
                      ) : (
                        <div className="available-time-slot">
                          <ul>
                            {timeSlotsData.map((slot, index) => (
                              <li
                                key={index}
                                onClick={() => handleSlotClick(index)}
                                className={
                                  selectedTimeSlots.includes(slot)
                                    ? "selecteds"
                                    : ""
                                }
                              >
                                {slot}
                              </li>
                            ))}
                          </ul>
                        </div>
                      )}

                      <button
                        className="btn btn-primary"
                        onClick={handleConfirm}
                      >
                        Confirm
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </Col>
          </div>
        </div>
      )}
    </>
  );
}
